export const DATA_KEYS = {
  BRANCHES: 'branches',
  PARENT_COMPANIES: 'parentCompanies',
  SUBSIDIARIES: 'subsidiaries',
  ASSOCIATES: 'associates',
  RELATED_COMPANIES: 'relatedCompanies',
  OWNERSHIP_TYPES: 'structure',
}
